import "plyr-react/plyr.css";
import ReactPlayer from "react-player";
import React, {useEffect, useRef, useState} from "react";
import CourseService from "../../services/CourseService";
import Hls from "hls.js";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";

interface Props {
    url: string;
    poster?: string;
    lessonId?: number;
    onEnd?: () => void;
}

(window as any).Hls = Hls;

export const HlsLessonPlayer = ({url, poster, lessonId, onEnd}: Props) => {

    const playerRef = useRef<ReactPlayer>(null);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    }, [url, lessonId]);

    const handlePlay = () => {
        const id = setInterval(async () => {
            if (playerRef.current) {
                const time = playerRef.current.getCurrentTime();
                const minute = Math.floor(time / 60);
                if (lessonId && minute > 0) {
                    await CourseService.watchLesson(lessonId, minute);
                }
            }
        }, 60000); // every 60 seconds
        setIntervalId(id);
    };

    const handlePause = () => {
        if (intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    };

    const handleEnded = () => {
        if (intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
        if (onEnd) {
            onEnd();
        }
    };

    return (
        <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 aspect ratio */, backgroundColor: 'black' }}>
            <ReactPlayer
                ref={playerRef}
                width='100%'
                height='100%'
                style={{ position: 'absolute', top: 0, left: 0 }}
                url={url}
                controls
                playing={true}
                fallback={
                    <div
                        style={{
                            height: '100%',
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Spin indicator={<LoadingOutlined style={{fontSize: 48}} spin/>}/>
                    </div>
                }
                light={poster}
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={handleEnded}
                config={{
                    file: {
                        hlsOptions: {
                            maxBufferLength: 30,
                            maxMaxBufferLength: 50,
                            xhrSetup: function (xhr: any, url: any) {
                                xhr.withCredentials = true // send cookies
                            }
                        },
                        attributes: {
                            onContextMenu: (e: any) => e.preventDefault(), // disable right click
                        },
                    },
                }}
            />
        </div>
    );

};